import { render, staticRenderFns } from "./ChangeTranslate.vue?vue&type=template&id=6a8210f0"
import script from "./ChangeTranslate.vue?vue&type=script&lang=js"
export * from "./ChangeTranslate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports